import React from "react";

export default function Contact() {
    return (
        <iframe src={"/website/contact.html"} className="full-iframe" />
    );
}
